import * as React from "react";
import type { FC, PropsWithChildren } from "react";

export const SimpleRow: FC<PropsWithChildren<{}>> = props => <tr>{props.children}</tr>;
